/* ============================================================================
   ENGORI — Warenkorb: Countdown und Nachlegen-Knopf
   ----------------------------------------------------------------------------
   Angelegt 2026-08-23.

   Zwei kleine, voneinander unabhängige Bausteine:

     1. Countdown im Kopf der Summenbox
     2. "+ 1 dazulegen" in der Fortschrittskarte

   Beide arbeiten ohne Abhängigkeit zum externen Shrine-Skript und scheitern
   still, wenn ihr Element fehlt.
   ========================================================================= */
(function () {
  'use strict';

  /* Locale-Präfix beachten (/de/cart statt /cart), sonst antwortet Shopify
     je nach Sprachdomain mit einer Weiterleitung statt mit JSON. */
  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ==========================================================================
     1. Countdown
     --------------------------------------------------------------------------
     Der Startpunkt liegt in sessionStorage, nicht im Speicher der Seite. Sonst
     stünde nach jedem Blättern wieder "10:00" — ein Countdown, der bei jedem
     Seitenaufruf von vorn beginnt, entlarvt sich beim ersten Zurückklicken
     selbst.

     Nach Ablauf wird nichts entfernt und nichts nachgeladen. Der Chip wechselt
     auf einen Hinweis ohne Zeitangabe, damit niemand einen Verlust erwartet,
     der gar nicht eintritt.
     ====================================================================== */

  var SPEICHER_SCHLUESSEL = 'eng_cart_timer_start';

  function startpunkt(dauerMs) {
    var jetzt = Date.now();
    var gespeichert;

    try {
      gespeichert = parseInt(sessionStorage.getItem(SPEICHER_SCHLUESSEL), 10);
    } catch (err) {
      /* Privater Modus oder gesperrter Speicher: dann eben ohne Gedächtnis. */
      return jetzt;
    }

    /* Kein Eintrag, unlesbar, in der Zukunft oder älter als die Laufzeit:
       neu beginnen. Der Zukunftsfall fängt eine verstellte Systemuhr ab. */
    if (!gespeichert || gespeichert > jetzt || jetzt - gespeichert > dauerMs) {
      try {
        sessionStorage.setItem(SPEICHER_SCHLUESSEL, String(jetzt));
      } catch (err) {
        /* still */
      }
      return jetzt;
    }

    return gespeichert;
  }

  function zweistellig(zahl) {
    return zahl < 10 ? '0' + zahl : String(zahl);
  }

  function countdownStarten(el) {
    var anzeige = el.querySelector('[data-eng-timer-anzeige]');
    if (!anzeige) return;

    var minuten = parseInt(el.getAttribute('data-minuten'), 10);
    if (!minuten || minuten < 1) minuten = 10;

    var dauerMs = minuten * 60 * 1000;
    var beginn = startpunkt(dauerMs);

    /* Erst jetzt sichtbar machen: Ohne JavaScript soll kein toter Chip mit
       eingefrorener Zeit stehen bleiben. */
    el.hidden = false;

    function abgelaufen() {
      el.setAttribute('data-abgelaufen', 'true');

      /* Die feste Beschriftung steht VOR der Zahl ("reserviert noch 4:12").
         Wird nur die Zahl ersetzt, entsteht "reserviert noch keine Eile" —
         kein Satz. Deshalb verschwindet die Beschriftung mit der Zahl. */
      var beschriftung = el.querySelector('.eng-sum__timer-text');
      if (beschriftung) beschriftung.remove();

      anzeige.textContent = 'kein Zeitdruck';
    }

    function schritt() {
      var rest = dauerMs - (Date.now() - beginn);

      if (rest <= 0) {
        abgelaufen();
        return;
      }

      var sekundenGesamt = Math.floor(rest / 1000);
      anzeige.textContent = Math.floor(sekundenGesamt / 60) + ':' + zweistellig(sekundenGesamt % 60);
      window.setTimeout(schritt, 1000);
    }

    schritt();
  }

  /* ==========================================================================
     2. "+ 1 dazulegen"
     --------------------------------------------------------------------------
     Erhöht die Menge der ersten Warenkorbzeile. Das Muster für das Nachladen
     ist dasselbe wie im Bundle-Modal (assets/engori-bundle-modal.js): liegt
     eine Schublade mit renderContents vor, bekommt sie den neuen Zustand;
     auf der Warenkorbseite selbst wird neu geladen, weil dort zwei Sections
     gleichzeitig neu gerechnet werden müssen (Artikel UND Summe).
     ====================================================================== */

  function nachlegen(knopf) {
    var variantenId = knopf.getAttribute('data-variant-id');
    if (!variantenId || knopf.getAttribute('aria-busy') === 'true') return;

    var menge = parseInt(knopf.getAttribute('data-menge'), 10) || 1;
    var urspruenglich = knopf.textContent;

    knopf.setAttribute('aria-busy', 'true');
    knopf.disabled = true;
    knopf.textContent = 'einen Moment …';

    var drawer = document.querySelector('cart-drawer');
    var aufCartSeite = !!document.getElementById('main-cart-items');
    var rumpf = { items: [{ id: Number(variantenId), quantity: menge }] };

    if (!aufCartSeite && drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        rumpf.sections = drawer
          .getSectionsToRender()
          .map(function (s) { return s.id; })
          .join(',');
        rumpf.sections_url = window.location.pathname;
      } catch (err) {
        /* Sections sind optional — renderContents holt sie sonst selbst. */
      }
    }

    fetch(wurzel() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(rumpf)
    })
      .then(function (res) {
        return res.json().then(function (zustand) {
          if (!res.ok) {
            throw new Error(zustand.description || zustand.message || 'Konnte nicht hinzugefügt werden.');
          }
          return zustand;
        });
      })
      .then(function (zustand) {
        if (aufCartSeite) {
          window.location.reload();
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(zustand);
        } else {
          window.location.href = wurzel() + 'cart';
        }
      })
      .catch(function (err) {
        knopf.textContent = err.message || 'Hat nicht geklappt';
        window.setTimeout(function () {
          knopf.textContent = urspruenglich;
          knopf.disabled = false;
          knopf.removeAttribute('aria-busy');
        }, 2600);
      });
  }

  /* ==========================================================================
     Verdrahtung
     --------------------------------------------------------------------------
     Der Knopf wird über einen Zuhörer am Dokument angebunden, nicht am Element
     selbst: Die Fortschrittskarte liegt innerhalb von .js-contents und wird bei
     jeder Mengenänderung durch frisches Markup ersetzt. Ein direkt gesetzter
     Zuhörer wäre danach weg.

     Der Countdown dagegen sitzt ausserhalb des ausgetauschten Bereichs und
     wird deshalb nur einmal gestartet.
     ====================================================================== */

  function init() {
    document.querySelectorAll('[data-eng-timer]').forEach(function (el) {
      if (el.dataset.engBereit) return;
      el.dataset.engBereit = '1';
      countdownStarten(el);
    });
  }

  document.addEventListener('click', function (ereignis) {
    var knopf = ereignis.target.closest('[data-eng-nachlegen]');
    if (!knopf) return;
    ereignis.preventDefault();
    nachlegen(knopf);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Die Schublade wird beim Öffnen erst befüllt — dann kann dort ein zweiter
     Countdown auftauchen, der noch nicht läuft. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:refresh', init);
})();
